export const getMe = (state) => state?.me;
export const getDocuments = (state) => state?.documents;

export const getStats = (state) => state?.stats;
